// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__2dqSL","footer":"style_footer__1dMuo","inner":"style_inner__2u6hD","copy":"style_copy__1U5Wu","nav":"style_nav__3tw8_","link":"style_link__3KBJh"};